import { resolveFieldMode } from './resolveFieldMode';
import type { CapabilityControlProps } from './types';

/** 字段只读：显式 readonly 或块级 preview */
export function isFieldReadonly(fieldPath: string, control: CapabilityControlProps): boolean {
  const mode = resolveFieldMode(fieldPath, control);
  return mode === 'readonly' || control.blockMode === 'preview';
}

/** 字段禁用：显式 disabled（不含 preview/readonly） */
export function isFieldDisabled(fieldPath: string, control: CapabilityControlProps): boolean {
  return resolveFieldMode(fieldPath, control) === 'disabled';
}

/** 控件不可交互：readonly 或 disabled */
export function isFieldInteractionLocked(fieldPath: string, control: CapabilityControlProps): boolean {
  return isFieldReadonly(fieldPath, control) || isFieldDisabled(fieldPath, control);
}
